import * as React from "react";
import classnames from "classnames";

/**
 * Used to truncate text from left, for example in long file paths e.g. ".../Dirname/Dirname01"
 * Current approach handles only text with default font size (16px)
 * and max-width limited by 300px (should be set via css)
 */
export const EllipsisLeft = ({
  text,
  color = "black",
  maxWidth = 400,
}: {
  text: string;
  color?: string;
  maxWidth?: number;
}) => {
  const [divClassName, setClassName] = React.useState("ellipsis-left");
  const [offsetWidthValue, setOffsetWidthValue] = React.useState(0);
  const spanRef: React.RefObject<HTMLSpanElement> = React.useRef();
  const divRef: React.RefObject<HTMLDivElement> = React.useRef();
  React.useLayoutEffect(() => {
    if (spanRef.current && spanRef.current.offsetWidth && spanRef.current.offsetWidth !== offsetWidthValue) {
      setOffsetWidthValue(spanRef.current.offsetWidth);
      setClassName(
        classnames("ellipsis-left", { truncated: spanRef.current.offsetWidth > divRef.current.offsetWidth })
      );
    }
  }, [offsetWidthValue]);
  return (
    <div className={divClassName} data-color={color} data-text={text} title={text} style={{ maxWidth }} ref={divRef}>
      <span ref={spanRef}>{text}</span>
    </div>
  );
};
